import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=6d865e3a&"
import script from "./Uploader.vue?vue&type=script&lang=js&"
export * from "./Uploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d865e3a')) {
      api.createRecord('6d865e3a', component.options)
    } else {
      api.reload('6d865e3a', component.options)
    }
    module.hot.accept("./Uploader.vue?vue&type=template&id=6d865e3a&", function () {
      api.rerender('6d865e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Uploader.vue"
export default component.exports